import type { TaskCardProps } from "./interfaces";
import { useSignal } from "@preact/signals";
import { FC } from "preact/compat";
import { IconButton } from "~/components";
import { Sidebar } from "./Sidebar";
import { View } from "./View";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";
import cn from "classnames";

const TaskCard: FC<TaskCardProps> = ({ task: initialTask, onCancel }) => {
    const task = useSignal(initialTask);

    const update = () => (task.value = task.value ? { ...task.value } : null);

    return (
        <div
            className={cn(
                "container bg-white flex pt-6 pl-4 pr-8 pb-10 lg:pb-6 rounded shadow-lg relative border border-gray-300",
                "h-[calc(100vh-50px)] max-h-[calc(100vh-50px)] lg:h-[82vh] lg:max-h-[82vh]",
                "max-w-[calc(100vw-50px)] w-[1280px]"
            )}
        >
            <div className="w-full px-6 py-2 overflow-y-overlay">
                <View task={task.value} onRefresh={update} />
            </div>
            <div className="lg:min-w-[420px] min-w-[320px] ml-2 overflow-y-overlay pr-2">
                <Sidebar task={task.value} onRefresh={update} />
            </div>
            <div className="absolute right-2 bottom-1 lg:-right-14 lg:top-0">
                <IconButton onClick={onCancel}>
                    <CloseIcon width="24" height="24" />
                </IconButton>
            </div>
        </div>
    );
};

export default TaskCard;
